import { createAction, props } from '@ngrx/store';

// Contact Actions
export const loadContacts = createAction(
  '[CRM] Load Contacts',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    filters?: {
      name?: string;
      surname?: string;
      email?: string;
      phone_number?: string;
    };
    sortBy?: 'created_at' | 'person_name' | 'company_name' | 'deal_name';
    sortDir?: 'asc' | 'desc';
    dateRange?: string;
  }>()
);

export const loadContactsSuccess = createAction(
  '[CRM] Load Contacts Success',
  props<{ result: any; pagination: any }>()
);

export const loadContactsFailure = createAction(
  '[CRM] Load Contacts Failure',
  props<{ error: any }>()
);

export const createContact = createAction(
  '[CRM] Create Contact',
  props<{ contact: any }>()
);

export const createContactSuccess = createAction(
  '[CRM] Create Contact Success',
  props<{ result: any }>()
);

export const createContactFailure = createAction(
  '[CRM] Create Contact Failure',
  props<{ error: any }>()
);

export const createCompanyContact = createAction(
  '[CRM] Create Company Contact',
  props<{ company_id: number; contact_id: number; is_default: number }>()
);

export const createCompanyContactSuccess = createAction(
  '[CRM] Create Company Contact Success',
  props<{ result: any }>()
);

export const createCompanyContactFailure = createAction(
  '[CRM] Create Company Contact Failure',
  props<{ error: any }>()
);

export const deleteCompanyContact = createAction(
  '[CRM] Delete Company Contact',
  props<{ id: number }>()
);

export const deleteCompanyContactSuccess = createAction(
  '[CRM] Delete Company Contact Success',
  props<{ id: number }>()
);

export const deleteCompanyContactFailure = createAction(
  '[CRM] Delete Company Contact Failure',
  props<{ error: any }>()
);

export const updateContact = createAction(
  '[CRM] Update Contact',
  props<{ id: number; contact: any }>()
);

export const updateContactSuccess = createAction(
  '[CRM] Update Contact Success',
  props<{ result: any }>()
);

export const updateContactFailure = createAction(
  '[CRM] Update Contact Failure',
  props<{ error: any }>()
);

export const deleteContact = createAction(
  '[CRM] Delete Contact',
  props<{ id: number }>()
);

export const deleteContactSuccess = createAction(
  '[CRM] Delete Contact Success',
  props<{ id: number }>()
);

export const deleteContactFailure = createAction(
  '[CRM] Delete Contact Failure',
  props<{ error: any }>()
);

export const loadContactsLookup = createAction('[CRM] Load Contacts Lookup');

export const loadContactsLookupSuccess = createAction(
  '[CRM] Load Contacts Lookup Success',
  props<{ result: any[] }>()
);

export const loadContactsLookupFailure = createAction(
  '[CRM] Load Contacts Lookup Failure',
  props<{ error: any }>()
);

export const loadContactDetail = createAction(
  '[CRM] Load Contact Detail',
  props<{ id: string }>()
);

export const loadContactDetailSuccess = createAction(
  '[CRM] Load Contact Detail Success',
  props<{ result: any }>()
);

export const loadContactDetailFailure = createAction(
  '[CRM] Load Contact Detail Failure',
  props<{ error: any }>()
);

// Company Actions
export const loadCompanies = createAction(
  '[CRM] Load Companies',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    sortBy?: 'created_at' | 'person_name' | 'company_name' | 'deal_name';
    sortDir?: 'asc' | 'desc';
    dateRange?: string;
  }>()
);

export const loadCompaniesSuccess = createAction(
  '[CRM] Load Companies Success',
  props<{ result: any; pagination: any }>()
);

export const loadCompaniesFailure = createAction(
  '[CRM] Load Companies Failure',
  props<{ error: any }>()
);

export const createCompany = createAction(
  '[CRM] Create Company',
  props<{ company: any }>()
);

export const createCompanySuccess = createAction(
  '[CRM] Create Company Success',
  props<{ result: any }>()
);

export const createCompanyFailure = createAction(
  '[CRM] Create Company Failure',
  props<{ error: any }>()
);

export const updateCompany = createAction(
  '[CRM] Update Company',
  props<{ id: number; company: any }>()
);

export const updateCompanySuccess = createAction(
  '[CRM] Update Company Success',
  props<{ result: any }>()
);

export const updateCompanyFailure = createAction(
  '[CRM] Update Company Failure',
  props<{ error: any }>()
);

export const deleteCompany = createAction(
  '[CRM] Delete Company',
  props<{ id: number }>()
);

export const deleteCompanySuccess = createAction(
  '[CRM] Delete Company Success',
  props<{ id: number }>()
);

export const deleteCompanyFailure = createAction(
  '[CRM] Delete Company Failure',
  props<{ error: any }>()
);

export const loadCompaniesLookup = createAction('[CRM] Load Companies Lookup');

export const loadCompaniesLookupSuccess = createAction(
  '[CRM] Load Companies Lookup Success',
  props<{ result: any[] }>()
);

export const loadCompaniesLookupFailure = createAction(
  '[CRM] Load Companies Lookup Failure',
  props<{ error: any }>()
);

export const loadCompanyDetail = createAction(
  '[CRM] Load Company Detail',
  props<{ id: string }>()
);

export const loadCompanyDetailSuccess = createAction(
  '[CRM] Load Company Detail Success',
  props<{ result: any }>()
);

export const loadCompanyDetailFailure = createAction(
  '[CRM] Load Company Detail Failure',
  props<{ error: any }>()
);

// Deal Actions
export const loadDeals = createAction(
  '[CRM] Load Deals',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    stage?: string;
    sortBy?: 'created_at' | 'person_name' | 'company_name' | 'deal_name';
    sortDir?: 'asc' | 'desc';
    dateRange?: string;
  }>()
);

export const loadDealsSuccess = createAction(
  '[CRM] Load Deals Success',
  props<{ result: any; pagination: any }>()
);

export const loadDealsFailure = createAction(
  '[CRM] Load Deals Failure',
  props<{ error: any }>()
);

export const createDeal = createAction(
  '[CRM] Create Deal',
  props<{ deal: any }>()
);

export const createDealSuccess = createAction(
  '[CRM] Create Deal Success',
  props<{ result: any }>()
);

export const createDealFailure = createAction(
  '[CRM] Create Deal Failure',
  props<{ error: any }>()
);

export const updateDeal = createAction(
  '[CRM] Update Deal',
  props<{ id: number; deal: any }>()
);

export const updateDealSuccess = createAction(
  '[CRM] Update Deal Success',
  props<{ result: any }>()
);

export const updateDealFailure = createAction(
  '[CRM] Update Deal Failure',
  props<{ error: any }>()
);

export const deleteDeal = createAction(
  '[CRM] Delete Deal',
  props<{ id: number }>()
);

export const deleteDealSuccess = createAction(
  '[CRM] Delete Deal Success',
  props<{ id: number }>()
);

export const deleteDealFailure = createAction(
  '[CRM] Delete Deal Failure',
  props<{ error: any }>()
);

export const loadDealDetail = createAction(
  '[CRM] Load Deal Detail',
  props<{ id: string }>()
);

export const loadDealDetailSuccess = createAction(
  '[CRM] Load Deal Detail Success',
  props<{ result: any }>()
);

export const loadDealDetailFailure = createAction(
  '[CRM] Load Deal Detail Failure',
  props<{ error: any }>()
);

// Save Report to CRM Actions
export const saveReportToCrm = createAction(
  '[CRM] Save Report To CRM',
  props<{ searchId: number; config?: any }>()
);

export const saveReportToCrmSuccess = createAction(
  '[CRM] Save Report To CRM Success',
  props<{ result: any }>()
);

export const saveReportToCrmFailure = createAction(
  '[CRM] Save Report To CRM Failure',
  props<{ error: any }>()
);
